<script setup lang="ts">
import { useChatStore } from '@/stores/chatStore.ts'
import { computed, onMounted, onUnmounted, watch } from 'vue'
import ChatMessages from '@/components/Sections/Communication/ChatRoom/ChatMessages.vue'
import ChatInput from '@/components/Sections/Communication/ChatRoom/ChatInput.vue'
import ChatRoomHeader from '@/components/Sections/Communication/ChatRoom/ChatRoomHeader.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'

/**
 * Stores
 */
const chatStore = useChatStore()

/**
 * Computed
 */
const chatRoom = computed(() => {
  return chatStore.getRoomById(chatStore.activeRoomId)
})

/**
 * Mark room as read when opening it
 */
const markCurrentRoomAsRead = () => {
  if (chatStore.activeRoomId > 0 && chatStore.roomMessages.has(chatStore.activeRoomId)) {
    const messages = chatStore.roomMessages.get(chatStore.activeRoomId)
    if (messages && messages.size > 0) {
      chatStore.setRoomAsRead(chatStore.activeRoomId)
    }
  }
}

/**
 * Lifecycle
 */
onMounted(() => {
  chatStore.setVisibleRoomId(chatStore.activeRoomId)
  // Mark current room as read when component mounts
  markCurrentRoomAsRead()
})

onUnmounted(() => {
  // Don't reset activeRoomId to 0 - let it persist so user returns to same room
  // chatStore.setActiveRoomId(0)
})

/**
 * Watch for room changes and mark as read
 */
watch(() => chatStore.activeRoomId, (newRoomId) => {
  if (newRoomId > 0) {
    // Mark the newly opened room as read
    markCurrentRoomAsRead()
  }
})

</script>

<template>
  <div v-if="chatRoom" class="flex-grow flex flex-col mr-2 height-limit">
    <ChatRoomHeader />
    <ChatMessages />
    <ChatInput />
  </div>
  <StandardCard v-else title="Your chat rooms" class="mr-2">
    <p>
      Engage in direct communication with other empires through chat. To start a conversation, you
      first need to meet them and initiate a chat by clicking the "+" button in the left sidebar.
    </p>
    <p>
      Please maintain a respectful tone in your conversations to avoid the risk of being banned from
      the game.
    </p>
  </StandardCard>
</template>

<style scoped lang="scss"></style>
